import type { KieGeneralModelConfig } from './types';
import { googleConfigs } from './configs/google';

/**
 * 模型配置映射
 */
export const kieGeneralModelConfigs: Record<string, KieGeneralModelConfig> = {
    ...googleConfigs,
};
